/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {MarcaListComponent} from "./marca-list/marca-list.component";
import {MarcaFormComponent} from "./marca-form/marca-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class MarcasRoutingModule {}


export const marcasRoutes: any[] = [
  {
    path: '',
    component: MarcaListComponent
  },{
    path: editRoute + '/:id',
    component: MarcaFormComponent
  },{
    path: newRoute,
    component: MarcaFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/marcas-routing.module.ts
 **/